<template>
  <a class="rs-listing__card rs-news-listing__card" :href="post.permalink">
    <div
      class="rs-listing__card__image rs-news-listing__card__image"
      v-html="post.featured_image"
    ></div>
    <div
      class="rs-listing__card__categories rs-news-listing__card__date"
      v-html="post.post_date"
    ></div>
    <div
      class="rs-listing__card__title rs-news-listing__card__title"
      v-html="post.post_title"
    ></div>
    <div class="rs-listing__card__footer rs-news-listing__card__footer">
      <div class="rs-listing__card__footer__cta">
        <span v-html="strings['Read More']" /> &gt;
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    // baseURL: String,
    post: Object,
    strings: Object,
  },
};
</script>
